import React, {useEffect, useState} from 'react'

function MsgAlert({alert}) {
  const [msg, setMsg] = useState(null);
  useEffect(() => {
    setMsg(alert)
    setTimeout(() => setMsg(null), 3000);
  }, [alert]);

    if (msg) {
        return (
            <div className='bg-blue-400 max-w-[200px] flex justify-center align-middle rounded-lg shadow-md text-white w-full p-2 text-center absolute top-16 right-4 z-40'>
                <p className='p-0 m-0 font-semibold text-[9pt]'>{msg}</p>
            </div>
        )
    }
}
export default MsgAlert